import initialState from './adminInitialState';
import mutations from './adminMutation';
import actions from './adminAction';

const getters = {
  isSmacAdmin: (state) => !!(state.current && state.current.corporationId === 1),
  isManufactureAdmin: (state) => !!(state.current
    && (state.current.corporationId === 2
      || state.current.corporationId === 3)),
  adminRole: (state) => state.current.role.toLowerCase(),
  allBranches: (state, getter) => (showAll) => {
    const { partnerList, adminFilter } = state;
    const { isSmacAdmin } = getter;
    if (partnerList.length === 0) return [];

    let branchCopy = partnerList.slice();

    if (adminFilter.partner && isSmacAdmin) {
      const {
        engagementLevel, psm, status, type,
      } = adminFilter.partner;

      branchCopy = branchCopy.filter((branch) => {
        const matchesPsm = psm ? psm === -1 ? true : branch.psmId === psm : true;
        const matchesStatus = status ? branch.status === status : true;
        const matchesEng = engagementLevel ? branch.engagementLevel === engagementLevel : true;
        const matchesType = type.length ? type.includes(branch.corpStatus) : true;

        return matchesPsm && matchesStatus && matchesType && matchesEng;
      });
    }

    if (!showAll) {
      branchCopy.shift();
    }

    return branchCopy.map((branch) => ({
      label: branch.corporationName,
      value: branch.id,
    }));
  },
  partnerSettings: (state) => state.partnerSettings,
};

const adminModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default adminModule;
